import { NotLoggedInError } from '../user/not-logged-in-error';
import { PreCheckErrorMixin } from './pre-check-error';

export class NotLoggedInPreCheckError extends PreCheckErrorMixin(NotLoggedInError) {
    constructor() {
        super();
    }
}
